var app = angular.module('leonardo');

var WorkFlowItemStatus = function (TaskService) {
  return function (pk) {
    var status = '';
    if ((pk !== null) && (pk !== undefined) && (pk !== ''))
      switch (pk.toString()){
        case TaskService.WORKFLOW_STATUS_PENDING:
          status = 'Pending';
          break;
        case TaskService.WORKFLOW_STATUS_STARTED:
          status = 'In Progress';
          break;
        case TaskService.WORKFLOW_STATUS_PAUSED:
          status = 'Paused';
          break;
        case TaskService.WORKFLOW_STATUS_STOPPED:
          status = 'Stopped';
          break;
        case TaskService.WORKFLOW_STATUS_SOLVED:
          status = 'Completed';
          break;
        case TaskService.WORKFLOW_CANNOT_DO:
          status = 'Cannot do';
          break;
        case TaskService.WORKFLOW_STATUS_APPROVAL_IN_PROGRESS:
          status = 'Approval in progress';
          break;
        case TaskService.WORKFLOW_STATUS_APPROVAL_APPROVED:
          status = 'Approval Completed';
          break;
        case TaskService.WORKFLOW_STATUS_APPROVAL_REJECTED:
          status = 'Approval Terminated';
          break;
      }
    return status;
  }
};

app.filter('workflowItemStatus', ['TaskService', WorkFlowItemStatus]);

var WorkFlowStatus = function (WorkFlowInstanceService) {
  return function (pk) {
    var status = '';
    if ((pk !== null) && (pk !== undefined) && (pk !== ''))
      switch (pk.toString()){
        case WorkFlowInstanceService.STATUS_PENDING:
          status = 'Pending';
          break;
        case WorkFlowInstanceService.STATUS_STARTED:
          status = 'Started';
          break;
        case WorkFlowInstanceService.STATUS_CANCEL:
          status = 'Canceled';
          break;
        case WorkFlowInstanceService.STATUS_FINISHED:
          status = 'Finished';
          break;
      }
    return status;
  }
};

app.filter('workflowStatus', ['WorkFlowInstanceService', WorkFlowStatus]);
